export default __webpack_public_path__ + "static/media/chart-dine-in.7283aa4e.svg";